export default __webpack_public_path__ + "static/SP_bg_01-90faad598e8af37e5d80eb63572d67b3.png";